import { Link } from "react-router-dom";
import { slideToggle } from "./../../composables/slideToggle.js";
import { getEnvironment, getUserName } from "../../utils/auth.js";

function SidebarProfile() {
  // const navigate = useNavigate();

  const user = getUserName();
  const environment_id = getEnvironment();

  const handleProfileExpand = (e) => {
    e.preventDefault();

    var targetSidebar = document.querySelector(
      ".app-sidebar:not(.app-sidebar-end)"
    );
    var targetMenu = e.target.closest(".menu-profile");
    var targetProfile = document.querySelector("#appSidebarProfileMenu");
    var expandTime =
      targetSidebar &&
      targetSidebar.getAttribute("data-disable-slide-animation")
        ? 0
        : 250;

    if (targetProfile) {
      if (targetProfile.style.display === "block") {
        targetMenu.classList.remove("active");
      } else {
        targetMenu.classList.add("active");
      }
      slideToggle(targetProfile, expandTime);
      targetProfile.classList.toggle("expand"); // Atualiza o estado do perfil para acionar o useEffect, se necessário
    }
  };

  return (
    <div className="menu">
      <div className="menu-profile">
        <Link
          to="/"
          onClick={handleProfileExpand}
          className="menu-profile-link"
        >
          <div className="menu-profile-cover with-shadow"></div>
          <div className="menu-profile-image">
            <img src="../assets/img/user/user-13.jpg" alt="" />
          </div>
          <div className="menu-profile-info">
            <div className="row">
              <div className="col-12">
                {user !== undefined ? user : "Usuário"}
              </div>
              <div className="col-12">
                <small className="">
                  {environment_id !== undefined
                    ? `Código do sistema: ${environment_id}`
                    : "Ambiente"}
                </small>
              </div>
              {/* <div className="menu-caret ms-auto"></div> */}
            </div>
            {/* <small>Eder Jr Dev</small> */}
          </div>
        </Link>
      </div>
      {/* <div id="appSidebarProfileMenu" className="collapse">
        <div className="menu-item pt-5px">
          <div className="menu-link" onClick={() => navigate("admin")}>
            <div className="menu-icon">
              <i className="fa fa-cog"></i>
            </div>
            <div className="menu-text">Área do Administrador</div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default SidebarProfile;
